import './frontend.scss';

import A11yDialog from 'a11y-dialog';

(() => {
	const closeAnimationSpeed = 750;
	const autoplay = 1;

	const config = window.emInlineModalConfig;

	if (typeof config === 'undefined') {
		throw new Error('Could not find the inline modal configuration data.');
	}

	const init = () => {
		inlineModals();
		videoModals();
	};

	/**
	 * Inline modal:
	 *
	 * Example markup:
	 *   <button aria-controls="modal-1" aria-expanded="false">Open modal</button>
	 */
	const inlineModals = () => {
		const modalEls = document.querySelectorAll('.js-inline-modal');
		Array.from(modalEls).forEach((modalEl) => {
			const dialog = new A11yDialog(modalEl);
			const openEls = document.querySelectorAll(
				`[aria-controls="${modalEl.id}"]`
			);
			Array.from(openEls).forEach((openEl) => {
				openEl.addEventListener('click', (e) => {
					e.preventDefault();
					dialog.show();
				});
			});
			dialog.on('show', () => {
				Array.from(openEls).forEach((openEl) => {
					openEl.setAttribute('aria-expanded', 'true');
				});
			});
			dialog.on('hide', () => {
				Array.from(openEls).forEach((openEl) => {
					openEl.setAttribute('aria-expanded', 'false');
				});
			});
		});
	};

	/**
	 * Example markup:
	 *   <a href="https://www.youtube.com/watch?v=dbbque0Y4FU" class="js-video-modal" data-video-id="dbbque0Y4FU" data-video-provider="youtube" aria-expanded="false" role="button">Watch video</a>
	 */
	const videoModals = () => {
		const videoElements = document.querySelectorAll('.js-video-modal');

		Array.from(videoElements).forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();

				const id = el.getAttribute('data-video-id');
				const type = el.getAttribute('data-video-provider');

				if (!id || !type) return false;

				e.currentTarget.setAttribute('aria-expanded', 'true');

				openVideoModal(id, type);
			});
		});
	};

	const openVideoModal = (id, type) => {
		// Make sure the old modal is destroyed before creating a new one.
		const modalEl = document.getElementById(`modal-${id}`);
		if (modalEl !== null) {
			closeVideoModal(modalEl);
		}
		createVideoModal(id, type);
	};

	const createVideoModal = (id, type) => {
		const modalEl = document.createElement('div');
		const embedCode = getEmbedCode(id, type);

		if (embedCode) {
			modalEl.innerHTML = buildVideoModal(id, embedCode);
			document.body.appendChild(modalEl);

			const insertedModalEl = document.getElementById(`modal-${id}`);
			const dialog = new A11yDialog(insertedModalEl);
			dialog.show();
			dialog.on('hide', () => {
				closeVideoModal(insertedModalEl);
			});
		}
	};

	const closeVideoModal = (el) => {
		el.closeAnimationTimeout = setTimeout(() => {
			el.remove();
		}, closeAnimationSpeed);
		const videoElements = document.querySelectorAll('.js-video-modal');
		Array.from(videoElements).forEach((videoEl) => {
			videoEl.setAttribute('aria-expanded', 'false');
		});
	};

	const buildVideoModal = (id, embedCode) => {
		return `
      <div class="modal modal--video" id="modal-${id}" aria-hidden="true">
        <div class="modal__overlay" data-a11y-dialog-hide></div>
          <div class="modal__container modal__container--video" role="document">
            <div class="modal__responsive-wrapper">
              ${embedCode}
            </div>
          </div>
          <button class="modal__close modal__close--outside" aria-label="${config.text.close}" data-a11y-dialog-hide></button>
      </div>
    `;
	};

	const getEmbedCode = (id, type) => {
		switch (type) {
			case 'youtube': {
				return youTubeEmbed(id);
			}
			case 'vimeo': {
				return vimeoEmbed(id);
			}
			default:
				return false;
		}
	};

	const youTubeEmbed = (id) => {
		return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${id}?autoplay=${autoplay}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
	};

	const vimeoEmbed = (id) => {
		return `<iframe width="640" height="360" src="https://player.vimeo.com/video/${id}?autoplay=${autoplay}" frameborder="0" allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
	};

	window.addEventListener('DOMContentLoaded', init);
})();
